export interface ClipPunchSlot {
	ClipPunchSlotId: number | null;
	ClipId: number;
	SequenceOrder: number;
	HoleDia: number | null;
	Tolerance: string | null;
	PunchPartNumber: string | null;
	ButtonPartNumber: string | null;
	Quantity: number | null;
}

export interface Clip {
	ClipId: number | null;
	ClipPartNumber: string | null;
	CustomerClipPartNumber: string | null;
	Width: number;
	Height: number;
	Gauge: number | null;
	CoilGauge: number | null;
	CoilWidth: number | null;
	WidthTolerance: string | null;
	HeightTolerance: string | null;
	MaterialGradeId: number | null;
	MaterialGradeName: string | null;
	TestCheckCycle: number | null;
	DrawingNumber: string | null;
	DrawingPath: string | null;
	DrawingRevision: string | null;
	CustomerDrawingNumber: string | null;
	CustomerDrawingRevision: string | null;
	HolePattern: string;
	HoleGage: string | null;
	SideGage: string | null;
	EntryKeeperId: number | null;
	EntryKeeperCode: string | null;
	ExitKeeperId: number | null;
	ExitKeeperCode: string | null;
	BottomKeeperSetup: boolean | null;
	DieSetDrawingNumber: string | null;
	DieSetDrawingRevision: string | null;
	DieSetNumber: string | null;
	Comments: string | null;
	IsActive: boolean;
	HoleQty: number | null;
	HoleBreakdown: string | null;
	Slots: ClipPunchSlot[];
	CreatedBy: string | null;
	CreatedDate: Date | null;
	ModifiedBy: string | null;
	ModifiedDate: Date | null;
}

export const hasClipSlotContent = (s: ClipPunchSlot): boolean =>
	s.HoleDia != null ||
	(s.Tolerance?.trim() ?? "") !== "" ||
	(s.PunchPartNumber?.trim() ?? "") !== "" ||
	(s.ButtonPartNumber?.trim() ?? "") !== "";

export const CLIP_PUNCH_SLOT_EMPTY: ClipPunchSlot = {
	ClipPunchSlotId: null,
	ClipId: 0,
	SequenceOrder: 1,
	HoleDia: null,
	Tolerance: null,
	PunchPartNumber: null,
	ButtonPartNumber: null,
	Quantity: null,
};

export const CLIP_INITIAL_VALUES: Clip = {
	ClipId: null,
	ClipPartNumber: null,
	CustomerClipPartNumber: null,
	Width: 0,
	Height: 0,
	Gauge: null,
	CoilGauge: null,
	CoilWidth: null,
	WidthTolerance: null,
	HeightTolerance: null,
	MaterialGradeId: null,
	MaterialGradeName: null,
	TestCheckCycle: null,
	DrawingNumber: null,
	DrawingPath: null,
	DrawingRevision: null,
	CustomerDrawingNumber: null,
	CustomerDrawingRevision: null,
	HolePattern: "",
	HoleGage: null,
	SideGage: null,
	EntryKeeperId: null,
	EntryKeeperCode: null,
	ExitKeeperId: null,
	ExitKeeperCode: null,
	BottomKeeperSetup: null,
	DieSetDrawingNumber: null,
	DieSetDrawingRevision: null,
	DieSetNumber: null,
	Comments: null,
	IsActive: true,
	HoleQty: null,
	HoleBreakdown: null,
	Slots: [{ ...CLIP_PUNCH_SLOT_EMPTY }],
	CreatedBy: null,
	CreatedDate: null,
	ModifiedBy: null,
	ModifiedDate: null,
};
